import Dropdown from 'bootstrap/js/src/dropdown'
import each from 'lodash/each'

import { app, navigation } from '../utils/store'

import gsap from 'gsap'
import ScrollToPlugin from 'gsap/ScrollToPlugin'

gsap.registerPlugin(ScrollToPlugin)

class Dropdowns{
    create(entry){
        new Dropdown(entry)
        
        this.dropdownMenu = entry.nextElementSibling
        if(entry.nextElementSibling.classList.contains('dropdown-menu')){
            
            this.setHeight(entry)
            window.addEventListener('resize', () => this.setHeight(entry))
            
            if(app.device.mobile){ entry.addEventListener('click', () => { this.onClick(entry) }) }
        }
    }

    setHeight = (entry, height = 0) => {
        each(entry.nextElementSibling.children, (child) => { height += child.clientHeight })
        entry.nextElementSibling.style.setProperty('--dropdownmenu-height', `${height}px`)
    }

    onClick = (entry, height = 0) => {
        each(entry.nextElementSibling.children, (child) => { height += child.clientHeight })
        
        if(entry.classList.contains('show')){
            let scrollTop = navigation.current.scrollTop + height
            gsap.to(navigation.current, { duration: .4, scrollTo: scrollTop });
        }
    }
}

export const DropdownManager = new Dropdowns()